import SearchQuestionIcon from '@/components/icons/search-question'
import { Text } from '@/components/ui/text'
import { Flex } from '@/styled-system/jsx'

export default function SearchNoResults() {
  return (
    <Flex
      align='center'
      bgColor='#170D19'
      border='1px solid'
      borderColor='#251929'
      borderRadius='md'
      flex={1}
      gap='4'
      p='2.5'
    >
      <Flex
        align='center'
        bg='linear-gradient(116deg, #E90083 16.35%, #FF6864 120.33%)'
        borderRadius='sm'
        justify='center'
        shrink={0}
        h='48px'
        w='48px'
      >
        <SearchQuestionIcon size='xl' />
      </Flex>

      <Flex direction='column'>
        <Text
          as='span'
          textStyle='sm'
          fontWeight='semibold'
          lineHeight='normal'
        >
          OINK...No results found!
        </Text>
        <Text as='span' textStyle='sm' color='#AD9FB6'>
          It seems that our little pig hasn&rsquo;t found any oink here yet...
        </Text>
      </Flex>
    </Flex>
  )
}
